import {
  comparePlayersReducer,
  evolvedPlayersReducer,
  myClubReducer,
  myPlayersReducer,
  permissionsReducer,
  streamlineReducer,
} from "@repo/shared/redux";

import clubImportReducer from "./clubImport/clubImportSlice";
import evolutionsBuilderReducer from "./evolutions/evolutionsBuilderSlice";
import evolutionsReducer from "./evolutions/evolutionsSlice";
import frontPageReducer from "./frontPage/frontPageSlice";
import globalStateReducer from "./globalState/globalStateSlice";
import loadedContentReducer from "./loadedContent/loadedContentSlice";
import messageReducer from "./message/messageSlice";
import objectivesReducer from "./objectives/objectivesSlice";
import playStylesLabReducer from "./playStylesLab/playStylesLabSlice";
import playersReducer from "./players/playersSlice";
import sbcFiltersReducer from "./sbcs/sbcFiltersSlice";
import sbcsSetsReducer from "./sbcs/sbcSetsSlice";
import sbcsReducer from "./sbcs/sbcsSlice";
import defaultSquadBuilderReducer from "./squadBuilder/defaultSquadBuilder/defaultSquadBuilderSlice";
import tacticsReducer from "./tactics/tacticsSlice";
import userReducer from "./user/userSlice";

const reducer = {
  userReducer,
  clubImportReducer,
  comparePlayersReducer,
  evolvedPlayersReducer,
  sbcsSetsReducer,
  sbcFiltersReducer,
  messageReducer,
  loadedContentReducer,
  sbcsReducer,
  playersReducer,
  evolutionsReducer,
  defaultSquadBuilderReducer,
  tacticsReducer,
  globalStateReducer,
  myClubReducer,
  myPlayersReducer,
  evolutionsBuilderReducer,
  frontPageReducer,
  playStylesLabReducer,
  permissionsReducer,
  streamlineReducer,
  objectivesReducer,
};

export default reducer;
